import { Result, Row, Col, Button } from 'antd';
import { CustomNotification } from 'common/components';
import { PERMISSION_POST_TO_WALMART } from 'static/Permission';
import { useCheckPermissions } from 'hooks';

export const getDialogMessage = (error) => {
  if (error === 'Cannot get Walmart taxonomy.') {
    return 'Could not get Walmart schema now. Please contact our support.';
  }

  if (error === `Member does not have Walmart's authentication.`) {
    return `Member does not have Walmart's authentication. Please set up the Walmart authentication in Member System Settings.`;
  }

  return null;
};

export const getErrorView = ({
  error,
  handleClosePostToWalmartModal,
  isPostToModalOpen,
}) => {
  if (!error) return null;

  const errorDialogMessage = getDialogMessage(error);

  //* if the error not in in getDialogMessage it would be show as notification
  if (!errorDialogMessage && isPostToModalOpen) {
    CustomNotification.error(error);
    return {};
  }

  const ErrorViewRender = (
    <Result status='403' title={error} subTitle={errorDialogMessage} />
  );

  const footer = (
    <Row>
      <Col flex='auto'></Col>
      <Col>
        <Button type='default' onClick={handleClosePostToWalmartModal}>
          Close
        </Button>
      </Col>
    </Row>
  );

  return {
    ErrorViewRender,
    modalOverrideConfig: {
      footer,
      onCancel: handleClosePostToWalmartModal,
    },
  };
};

export const hasNoBrickCodeError = ({ walmartFormErrors }) => {
  return walmartFormErrors?.some((walmartFormError) =>
    walmartFormError?.dataErrors?.find((dataErrorItem) => {
      const { title, error } = dataErrorItem;
      if (title === 'Brick Code Name' && error === 'required field') {
        return true;
      }

      return false;
    })
  );
};

export const useCheckDisablePostProductTo = ({ selectedProducts }) => {
  if (!selectedProducts?.length) return true;

  const isSomeProductInvalid = selectedProducts?.some((productItem) => {
    if (productItem?.isOverlayProduct) {
      return true;
    }

    if (productItem?.isOwner === false) {
      //* some is not owner
      return true;
    }

    //* some is not active
    if (productItem?.status?.toLowerCase() !== 'active') {
      return true;
    }

    return false;
  });

  return !selectedProducts?.length || isSomeProductInvalid;
};

export const useCheckDisablePostProductToWalmart = ({ selectedProducts }) => {
  const hasPostToWalmartPermission = useCheckPermissions(
    PERMISSION_POST_TO_WALMART
  );

  return !hasPostToWalmartPermission || !selectedProducts?.length;
};
